import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 1 }

import CustomerSelect from '@/components/CustomerSelect.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import SubsidiarySelect from '@/components/SubsidiarySelect.vue';
import ClientSelect from '@/components/ClientSelect.vue';
import {computed, ref, watch, watchEffect} from 'vue';
import {useApplicationState} from '@/store/applicationState';
import {useSettings} from '@/store/settings';
import {doAlert} from '@/util';


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  emits: ['save'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const applicationState = useApplicationState();
const settingsStore = useSettings();
const missingSettings = computed((): string[] => {
  return applicationState.missingSettings;
});
const ready = computed((): boolean => {
  return settingsStore.ready;
});

settingsStore.fetchCustomers();

const client = ref(settingsStore.client);
const customerId = ref(settingsStore.customerId);
const userShort = ref(settingsStore.userShort);
const selectedSubsidiary = ref(settingsStore.selectedSubsidiary);
const selectedWarehouse = ref(settingsStore.selectedWarehouse);
const storageBinManagement = computed(() => settingsStore.sessionData?.Freischaltung.LagerplatzVerwaltung ?? false);

watch(customerId, () => {
  client.value = null;
});
const showSnackbar = ref(false);
const changesMade = ref(false);

watch(client, (newClient, oldClient) => {
  if (newClient === oldClient) return;

  if (newClient === null) {
    selectedSubsidiary.value = null;
    return;
  }

  selectedSubsidiary.value = settingsStore.selectedSubsidiary;
});

watch(selectedSubsidiary, async (newSubsidiary, oldSubsidiary) => {
  if (newSubsidiary === oldSubsidiary) return;

  if (client.value === null || newSubsidiary === null) {
    selectedWarehouse.value = null;
    return;
  }

  selectedWarehouse.value = settingsStore.selectedWarehouse;
});

watch(selectedWarehouse, (newWarehouse, oldWarehouse) => {
  if (newWarehouse === oldWarehouse) return;
});

watch(() => [client.value, selectedSubsidiary.value, selectedWarehouse.value, userShort.value], () => {
  changesMade.value = true;
});

const userShortCmp = computed<string>({
  get: () => settingsStore.sessionData?.Bediener.Kuerzel ?? userShort.value ?? '',
  set: (newVal: string) => userShort.value = newVal?.toUpperCase() ?? '',
});

const storageBinManagementCmp = computed<string>(() => storageBinManagement.value ? 'Aktiv' : 'Inaktiv');

watchEffect(() => {
  storageBinManagementCmp.value;
});

const save = async () => {
  try {
    settingsStore.customerId = customerId.value;
    settingsStore.client = client.value;
    settingsStore.selectedSubsidiary = selectedSubsidiary.value;
    settingsStore.selectedWarehouse = selectedWarehouse.value;
    settingsStore.userShort = userShort.value;
    emits('save');
    showSnackbar.value = true;
    changesMade.value = false;
  } catch (err: any) {
    await doAlert(err?.message, 'Fehler');
  }
};

function validateUserShort(val: string|null): string|true {
  if ((val?.length ?? 0) > 5) return 'zu lang';
  return true;
}

__expose({
  WarehouseSelect, SubsidiarySelect, ClientSelect, CustomerSelect,
  missingSettings,
  ready,
  userShort,
  selectedSubsidiary,
  selectedWarehouse,
  userShortCmp,
  storageBinManagementCmp,
  client,
  customerId,
  showSnackbar,
  changesMade,
  save,
  validateUserShort,
  settingsStore,
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (ready.value)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: ""
      }, {
        default: _withCtx(() => [
          (missingSettings.value.length > 0)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                text: "",
                density: "compact",
                type: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Fehlende Einstellungen:"),
                  _hoisted_1,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missingSettings.value, (missingSetting) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      size: "small",
                      key: missingSetting
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(missingSetting), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  }), 128))
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(CustomerSelect, {
            "use-model": "",
            "use-filter": "",
            "show-label": "",
            modelValue: customerId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerId).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(ClientSelect, {
            "use-model": "",
            "show-label": "",
            "customer-id": customerId.value ?? undefined,
            modelValue: client.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((client).value = $event))
          }, null, 8, ["customer-id", "modelValue"]),
          _createVNode(SubsidiarySelect, {
            client: client.value ?? undefined,
            "customer-id": customerId.value ?? undefined,
            "use-model": "",
            "show-label": "",
            modelValue: selectedSubsidiary.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSubsidiary).value = $event))
          }, null, 8, ["client", "customer-id", "modelValue"]),
          _createVNode(WarehouseSelect, {
            client: client.value ?? undefined,
            "customer-id": customerId.value ?? undefined,
            subsidiary: selectedSubsidiary.value ?? undefined,
            "use-model": "",
            "show-label": "",
            modelValue: selectedWarehouse.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedWarehouse).value = $event))
          }, null, 8, ["client", "customer-id", "subsidiary", "modelValue"]),
          _createVNode(_component_v_text_field, {
            "hide-details": "",
            class: "mt-3 mb-2",
            modelValue: storageBinManagementCmp.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((storageBinManagementCmp).value = $event)),
            label: "Lagerplatzverwaltung",
            disabled: true
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            "hide-details": "",
            class: "mt-3 mb-5",
            modelValue: userShortCmp.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userShortCmp).value = $event)),
            label: "Bedienerkürzel",
            maxlength: "5",
            disabled: Boolean(_unref(settingsStore).sessionData?.Bediener.Kuerzel),
            rules: [validateUserShort]
          }, null, 8, ["modelValue", "disabled", "rules"]),
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: save,
            disabled: !changesMade.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Speichern")
            ], undefined, true),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_snackbar, {
            modelValue: showSnackbar.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showSnackbar).value = $event)),
            timeout: "3000"
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showSnackbar.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Schließen")
                ], undefined, true),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Erfolgreich gespeichert ")
            ], undefined, true),
            _: 1
          }, 8, ["modelValue"])
        ], undefined, true),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}
}

})